{
  "en": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AFI": "Afars and Issas",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Åland Islands",
      "ALB": "Albania",
      "AND": "Andorra",
      "ANT": "Netherlands Antilles (The)",
      "ARE": "United Arab Emirates",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ASM": "American Samoa",
      "ATA": "Antarctica",
      "ATB": "British Antarctic Territory",
      "ATF": "French Southern Territories",
      "ATG": "Antigua and Barbuda",
      "ATN": "Queen Maud Land",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaijan",
      "BDI": "Burundi",
      "BEL": "Belgium",
      "BEN": "Benin",
      "BES": "Bonaire, Saint Eustatius and Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgaria",
      "BHR": "Bahrain",
      "BHS": "Bahamas",
      "BIH": "Bosnia and Herzegovina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Belarus",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivia",
      "BRA": "Brazil",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BUR": "Burma",
      "BVT": "Bouvet Island",
      "BWA": "Botswana",
      "BYS": "Belarus",
      "CAF": "Central African Republic",
      "CAN": "Canada",
      "CCK": "Cocos (Keeling) Islands",
      "CHE": "Switzerland",
      "CHL": "Chile",
      "CHN": "China",
      "CIV": "Cote d'Ivoire",
      "CMR": "Cameroon",
      "COD": "Congo",
      "COG": "Congo",
      "COK": "Cook Islands",
      "COL": "Colombia",
      "COM": "Comoros",
      "CPV": "Cape Verde",
      "CRI": "Costa Rica",
      "CSK": "Czechoslovakia",
      "CTE": "Canton and Enderbury Islands",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "Christmas Island",
      "CYM": "Cayman Islands",
      "CYP": "Cyprus",
      "CZE": "Czech Republic",
      "DDR": "East Germany",
      "DEU": "Germany",
      "DHY": "Dahomey",
      "DJI": "Djibouti",
      "DMA": "Dominica",
      "DNK": "Denmark",
      "DOM": "Dominican Republic",
      "DZA": "Algeria",
      "ECU": "Ecuador",
      "EGY": "Egypt",
      "ERI": "Eritrea",
      "ESH": "Western Sahara",
      "ESP": "Spain",
      "EST": "Estonia",
      "ETH": "Ethiopia",
      "FIN": "Finland",
      "FJI": "Fiji",
      "FLK": "Falkland Islands (Malvinas)",
      "FRA": "France",
      "FRO": "Faroe Islands",
      "FSM": "Micronesia",
      "FXX": "Metropolitan France",
      "GAB": "Gabon",
      "GBR": "United Kingdom",
      "GEL": "Gilbert Islands",
      "GEO": "Georgia",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadeloupe",
      "GMB": "Gambia",
      "GNB": "Guinea-Bissau",
      "GNQ": "Equatorial Guinea",
      "GRC": "Greece",
      "GRD": "Grenada",
      "GRL": "Greenland",
      "GTM": "Guatemala",
      "GUF": "French Guiana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hong Kong",
      "HMD": "Heard Island and Mcdonald Islands",
      "HND": "Honduras",
      "HRV": "Croatia",
      "HTI": "Haiti",
      "HUN": "Hungary",
      "HVO": "Upper Volta",
      "IDN": "Indonesia",
      "IMN": "Isle of Man",
      "IND": "India",
      "IOT": "British Indian Ocean Territory",
      "IRL": "Ireland",
      "IRN": "Iran",
      "IRQ": "Iraq",
      "ISL": "Iceland",
      "ISR": "Israel",
      "ITA": "Italy",
      "JAM": "Jamaica",
      "JEY": "Jersey",
      "JOR": "Jordan",
      "JPN": "Japan",
      "JTN": "Johnston Island",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KGZ": "Kyrgyzstan",
      "KHM": "Cambodia",
      "KIR": "Kiribati",
      "KNA": "Saint Kitts and Nevis",
      "KOR": "South Korea",
      "KWT": "Kuwait",
      "LAO": "Lao",
      "LBN": "Lebanon",
      "LBR": "Liberia",
      "LBY": "Libya",
      "LCA": "Saint Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Lithuania",
      "LUX": "Luxembourg",
      "LVA": "Latvia",
      "MAC": "Macao",
      "MAF": "Saint Martin (French Part)",
      "MAR": "Morocco",
      "MCO": "Monaco",
      "MDA": "Moldova",
      "MDG": "Madagascar",
      "MDV": "Maldives",
      "MEX": "Mexico",
      "MHL": "Marshall Islands",
      "MID": "Midway Islands",
      "MKD": "Macedonia",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolia",
      "MNP": "Northern Mariana Islands",
      "MOZ": "Mozambique",
      "MRT": "Mauritania",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MYT": "Mayotte",
      "NAM": "Namibia",
      "NCL": "New Caledonia",
      "NER": "Niger",
      "NFK": "Norfolk Island",
      "NGA": "Nigeria",
      "NHB": "New Hebrides",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "The Netherlands",
      "NOR": "Norway",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Neutral Zone",
      "NZL": "New Zealand",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCI": "Pacific Islands (Trust Territory)",
      "PCN": "Pitcairn",
      "PCZ": "Panama Canal Zone",
      "PER": "Peru",
      "PHI": "Philippines",
      "PHL": "Philippines",
      "PLW": "Palau",
      "PNG": "Papua New Guinea",
      "POL": "Poland",
      "PRI": "Puerto Rico",
      "PRK": "North Korea",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palestinian Territory, Occupied",
      "PUS": "United States Miscellaneous Pacific Islands",
      "PYF": "French Polynesia",
      "QAT": "Qatar",
      "REU": "Réunion",
      "RHO": "Southern Rhodesia",
      "ROU": "Romania",
      "RUS": "Russia",
      "RWA": "Rwanda",
      "SAU": "Saudi Arabia",
      "SCG": "Serbia and Montenegro",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "Singapore",
      "SGS": "South Georgia and the South Sandwich Islands",
      "SHN": "Saint Helena, Ascension and Tristan da Cunha",
      "SJM": "Svalbard and Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Solomon Islands",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "Saint Pierre and Miquelon",
      "SRB": "Serbia",
      "SSD": "South Sudan",
      "STP": "Sao Tome and Principe",
      "SUN": "USSR",
      "SUR": "Suriname",
      "SVK": "Slovakia",
      "SVN": "Slovenia",
      "SWE": "Sweden",
      "SWZ": "Swaziland",
      "SXM": "Sint Maarten (Dutch Part)",
      "SYC": "Seychelles",
      "SYR": "Syria",
      "TCA": "Turks and Caicos Islands",
      "TCD": "Chad",
      "TGO": "Togo",
      "THA": "Thailand",
      "TJK": "Tajikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "East Timor",
      "TMP": "Portuguese Timor",
      "TON": "Tonga",
      "TTO": "Trinidad and Tobago",
      "TUN": "Tunisia",
      "TUR": "Turkey",
      "TUV": "Tuvalu",
      "TWN": "Taiwan, Province Of China",
      "TZA": "Tanzania",
      "UGA": "Uganda",
      "UKR": "Ukraine",
      "UMI": "United States Minor Outlying Islands",
      "URY": "Uruguay",
      "USA": "United States",
      "UZB": "Uzbekistan",
      "VAT": "Vatican City",
      "VCT": "Saint Vincent and the Grenadines",
      "VDR": "North Vietnam",
      "VEN": "Venezuela",
      "VGB": "British Virgin Islands",
      "VIR": "Virgin Islands of the United States",
      "VNM": "South Vietnam",
      "VUT": "Vanuatu",
      "WAK": "Wake Island",
      "WLF": "Wallis and Futuna",
      "WSM": "Samoa",
      "XXX": "Unknown",
      "YEM": "North Yemen",
      "YMD": "South Yemen",
      "YUG": "Yugoslavia",
      "ZAF": "South Africa",
      "ZAR": "Zaire",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe"
    }
  }
}
